import React from "react";
import { IOrg } from "@schema";
import { AugmentedPersonMap } from "../onboarding-org-invite/OnboardingOrgInvite";
import { RelayRefetchProp, QueryRenderer, ReadyState } from "react-relay";
import { handleReadyStateError } from "@util/relay.util";
import { getEventMeetingsQuery } from "../onboarding-org-invite/OnboardingOrgInvite.gql";
import { ZonedMoment } from "@util/time-zone.util";
import { getValue } from "@util/errorable.util";
import { getSuggestedEvents } from "../onboarding-org-invite/OnboardingOrgInvite.util";
import { track, TrackingEvents } from "@util/analytics.util";

export const OnboardingOrgBulkInviteQueryRenderer = ({
  onEventsQueryComplete,
  org,
  relay,
}: {
  onEventsQueryComplete: (eventsToAttendeeMap?: { [keyof: string]: AugmentedPersonMap }) => void;
  org: IOrg;
  relay: RelayRefetchProp;
}) => {
  return (
    <QueryRenderer
      environment={relay.environment}
      query={getEventMeetingsQuery}
      variables={{
        orgRelayId: org.id,
        week: new ZonedMoment().add(1, "weeks").startOf("week").format("YYYY-MM-DD"),
      }}
      render={(readyState: ReadyState) => {
        const { error, props } = readyState;
        if (error) {
          handleReadyStateError(error, "OnbardingOrgInvite");
          onEventsQueryComplete();
          return null;
        }

        if (!props?.node?.calculateSmartHoldsErrorable) {
          return null;
        }
        // Grab events with their appropriate attendees from appropriate user events
        const smartHolds = getValue(props.node.calculateSmartHoldsErrorable);
        if (!smartHolds || !smartHolds?.events) {
          onEventsQueryComplete();
          return null;
        }
        const eventsMappedToAttendees = getSuggestedEvents(org, smartHolds.events);

        // Save all team attendees to personsGrabbedFromEventsCopy (for "select all" functionality)
        if (Object.keys(eventsMappedToAttendees).length) {
          track(TrackingEvents.ONBOARDING.ONBOARDING_INVITES_BULK_INVITE_VIEWED);
          onEventsQueryComplete(eventsMappedToAttendees);
        } else {
          onEventsQueryComplete();
        }
        return null;
      }}
    />
  );
};
